import React from 'react';
import { FaShareAlt, FaStar } from 'react-icons/fa';

export function ProductDetail () {
  const product = {
    name: 'Nama Produk',
    oldPrice: 100000,
    price: 75000,
    description: 'Deskripsi produk yang sangat menarik dan informatif.',
    rating: 4.5,
    reviews: 120,
    images: [
      'https://via.placeholder.com/300',
      'https://via.placeholder.com/300',
      'https://via.placeholder.com/300',
    ],
  };

  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col md:flex-row">
        <div className="md:w-1/2">
          <div className="mb-4">
            {product.images.map((img, index) => (
              <img key={index} src={img} alt={`Product ${index}`} className="w-full mb-2" />
            ))}
          </div>
        </div>
        <div className="md:w-1/2 md:pl-4">
          <h1 className="text-3xl font-bold mb-2">{product.name}</h1>
          <div className="text-gray-500 line-through">Rp {product.oldPrice.toLocaleString()}</div>
          <div className="text-2xl font-bold text-red-500 mb-4">Rp {product.price.toLocaleString()}</div>
          <div className="flex items-center mb-4">
            <FaStar className="text-yellow-500 mr-1" />
            <span className="mr-2">{product.rating}</span>
            <span>({product.reviews} reviews)</span>
          </div>
          <p className="mb-4">{product.description}</p>
          <div className="flex space-x-2 mb-4">
            <button className="bg-blue-500 text-white px-4 py-2 rounded-md flex items-center">
              <FaShareAlt className="mr-2" />
              Share
            </button>
            <button className="bg-green-500 text-white px-4 py-2 rounded-md">Pesan Sekarang</button>
          </div>
        </div>
      </div>
    </div>
  );
};
